import { INavItemProps } from 'components/atoms/NavItem'
import I18n from 'core/i18n'

const RELATED_POSTS_EDIT_PATH_REGEX = /^\/agent\/posts\/([0-9])*\/related_posts\/edit$/

export const NAV_ITEMS_AGENT: INavItemProps[] = [
  {
    href: '/agent/dashboard',
    iconName: 'grid_view',
    label: 'ダッシュボード',
    activate_paths: ['agent/dashboard'],
  },
  {
    href: '/agent/tours/weekly',
    iconName: 'event_note',
    label: 'OPカレンダー',
    activate_paths: ['weekly'],
  },
  {
    href: '/agent/ota_reservations',
    iconName: 'domain_verification',
    label: '予約一覧',
    activate_paths: ['/agent/ota_reservations'],
  },
  {
    href: '',
    iconName: 'groups',
    label: 'ツアー管理',
    defaultOpen: true,
    activate_paths: [
      'agent/ota_pending_reservations',
      'agent/host_reservations',
      'reservations',
      'agent/direct_reservations',
      'guide_reports',
      'trouble_reports',
      'agent/meetup_places',
      'agent/tasks',
      'agent/partner_venues',
    ],
    children: [
      {
        href: '/agent/ota_pending_reservations',
        label: '手動入力一覧',
        activate_paths: ['/agent/ota_pending_reservations'],
      },
      {
        href: '/agent/host_reservations',
        label: '自社サイト予約一覧',
        activate_paths: [
          /^\/agent\/host_reservations$/,
          /^\/reservations([a-zA-Z0-9\/])*$/,
          /^\/agent\/reservations\/([0-9])*\/edit_thanks_mails$/,
          /^\/agent\/direct_reservations([a-zA-Z0-9\/])*$/,
          /^\/direct_reservations\/([0-9])*\/guide_assigns\/for_direct_reservation$/,
          /^\/agent\/direct_reservations\/([0-9])*\/edit_thanks_mails$/,
        ],
      },
      {
        href: '/agent/meetup_places',
        label: '集合場所マスタ',
        activate_paths: ['/agent/meetup_places'],
      },
      {
        href: '/agent/tasks',
        label: 'Pvタスクマスタ',
        activate_paths: ['/agent/tasks'],
      },
      {
        href:
          '/agent/guide_reports?progresses[]=not_yet&progresses[]=draft&progresses[]=created&progresses[]=confirming&progresses[]=first_check_done',
        label: '終了報告',
        activate_paths: [/^\/agent\/guide_reports/],
      },
      {
        href: '/agent/trouble_reports',
        label: 'トラブル報告',
        activate_paths: [/^\/agent\/trouble_reports/],
      },
      {
        href: '/agent/partner_venues',
        label: '提携先予約照会',
        activate_paths: ['/agent/partner_venues'],
      },
    ],
  },
  {
    href: '',
    iconName: 'person_search',
    label: 'ガイド管理',
    defaultOpen: false,
    activate_paths: [
      'agent/guides',
      'agent/agent_skills',
      'agent/agent_tour_skills',
      'agent/agent_ranks',
      'agent/range_tags',
    ],
    children: [
      {
        href: '/agent/guides',
        label: 'ガイド検索',
        activate_paths: [
          'agent/guides',
          /^\/agent\/guides\/([0-9])*\/edit$/,
          'agent/guide_assignment_statuses',
        ],
      },
      {
        href: '/agent/agent_skills',
        label: 'スキル マスタ',
        activate_paths: ['/agent/agent_skills'],
      },
      {
        href: '/agent/agent_tour_skills',
        label: 'ツアースキル マスタ',
        activate_paths: ['/agent/agent_tour_skills'],
      },
      {
        href: '/agent/agent_ranks',
        label: 'ガイドランクマスタ',
        activate_paths: ['/agent/agent_ranks'],
      },
      {
        href: '/agent/range_tags',
        label: '期間タグ',
        activate_paths: ['/agent/range_tags'],
      },
    ],
  },
  {
    href: '',
    iconName: 'mail',
    label: 'テンプレ/お知らせ',
    defaultOpen: false,
    activate_paths: [
      'agent/sound_out_templates',
      'agent/formal_request_templates',
      'agent/connection_mail_templates',
      'agent/guide_notification_types',
      'agent/guide_announcements',
      'agent/terms_versions',
    ],
    children: [
      {
        href: '/agent/sound_out_templates',
        label: '打診 テンプレ',
        activate_paths: ['/agent/sound_out_templates'],
      },
      {
        href: '/agent/formal_request_templates',
        label: '正式依頼 テンプレ',
        activate_paths: ['/agent/formal_request_templates'],
      },
      {
        href: '/agent/connection_mail_templates',
        label: 'つなぐメール テンプレ',
        activate_paths: ['/agent/connection_mail_templates'],
      },
      {
        href: '/agent/tour_memo_templates',
        label: 'ツアーメモ テンプレ',
        activate_paths: ['/agent/tour_memo_templates'],
      },
      {
        href: '/agent/guide_notification_types',
        label: 'アプリ通知 テンプレ',
        activate_paths: ['/agent/guide_notification_types'],
      },
      {
        href: '/agent/guide_announcements',
        label: 'アプリお知らせ',
        activate_paths: ['/agent/guide_announcements'],
      },
      {
        href: '/agent/terms_versions',
        label: 'ガイド利用規約',
        activate_paths: ['/agent/terms_versions'],
      },
    ],
  },
  {
    href: '/agent/cancel_applications',
    iconName: 'domain_verification',
    label: 'キャンセル申請',
    activate_paths: ['/agent/cancel_applications'],
  },
  {
    href: '/agent/sales',
    iconName: 'payment',
    label: '売上管理',
    activate_paths: ['/agent/sales'],
  },
  {
    href: '',
    iconName: 'payment',
    label: '支払い管理',
    defaultOpen: false,
    activate_paths: ['payments', 'agent/payment_details'],
    children: [
      {
        href: '/agent/guide_payments',
        label: '支払管理',
        activate_paths: ['guide_payments'],
      },
      {
        href: '/agent/payment_details',
        label: 'ガイド支払い明細一覧',
        activate_paths: [/^\/agent\/payment_details/],
      },
    ],
  },
  {
    href: '/agent/reviews',
    iconName: 'star_border',
    label: 'レビュー',
    activate_paths: [/^\/agent\/reviews*$/],
  },
  {
    href: '/agent/posts',
    iconName: 'tour',
    label: 'ツアー',
    activate_paths: [
      /^\/agent\/posts/,
      /^\/agent\/dmc_tours/,
      'agent/member_posts',
      'agent/cancel_policies',
      'agent/related_posts',
      RELATED_POSTS_EDIT_PATH_REGEX,
      'agent/mail_templates',
    ],
    children: [
      {
        href: '/agent/posts',
        label: 'ツアー',
        activate_paths: [/^\/agent\/posts/, /^\/agent\/dmc_tours/],
      },
      {
        label: I18n.t('generic.member_posts'),
        href: '/agent/member_posts',
        activate_paths: ['agent/member_posts'],
      },
      {
        label: I18n.t('cancel_policy', { scope: 'activerecord.models' }),
        href: '/agent/cancel_policies',
        activate_paths: ['agent/cancel_policies'],
      },
      {
        label: I18n.t('generic.related_posts'),
        href: '/agent/related_posts',
        activate_paths: ['agent/related_posts', RELATED_POSTS_EDIT_PATH_REGEX],
      },
      {
        label: I18n.t('thanks_mail', { scope: 'mail_template' }),
        href: '/agent/mail_templates',
        activate_paths: ['agent/mail_templates'],
      },
    ],
  },
]

export const NAV_ITEMS_GUIDE: INavItemProps[] = [
  {
    href: '/agent/dashboard',
    iconName: 'grid_view',
    label: 'ダッシュボード',
    activate_paths: ['agent/dashboard'],
  },
  {
    href: '/notifications',
    iconName: 'notifications',
    label: '通知',
    activate_paths: ['notifications'],
  },
  {
    href: '/conversations',
    iconName: 'message',
    label: 'メッセージ',
    activate_paths: [
      /^\/conversations([a-zA-Z0-9\-\/])*$/g,
      /^\/reservations\/([0-9])*\/guide_assigns\/for_reservation$/,
      /^\/reservations\/([0-9])*\/tour_attend\/conversation$/,
    ],
  },
  {
    href: '/agent/host_reservations',
    iconName: 'domain_verification',
    label: '予約確認',
    activate_paths: [
      /^\/agent\/host_reservations$/,
      /^\/reservations([a-zA-Z0-9\/])*$/,
      /^\/agent\/reservations\/([0-9])*\/edit_thanks_mails$/,
      /^\/agent\/direct_reservations([a-zA-Z0-9\/])*$/,
      /^\/direct_reservations\/([0-9])*\/guide_assigns\/for_direct_reservation$/,
      /^\/agent\/direct_reservations\/([0-9])*\/edit_thanks_mails$/,
    ],
  },
  {
    href: '/agent/sales',
    iconName: 'payment',
    label: '売上管理',
    activate_paths: ['/agent/sales'],
  },
  {
    href: '/reviews',
    iconName: 'star_border',
    label: 'レビュー',
    activate_paths: [/^\/reviews*$/],
  },
  {
    href: '/favorites',
    iconName: 'favorite_border',
    label: 'お気に入り',
    activate_paths: ['favorites'],
  },
]
